export default {
  username: (state) => state.user && state.user.name,
  email: (state) => state.email,
  operations: (state) => state.user && state.user.operations,
  accessToken: (state) => state.accessToken,
  refreshToken: (state) => state.refreshToken,
};
